import { createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import {
  FORM_SUBMIT_FAILED,
  WRITING_FORM_SUBMIT_REQUESTED,
  FORM_SUBMIT_SUCCEEDED,
  FORM_LOADED,
  FORM_SUBMIT_START,
  FORM_SUBMIT_STOP,
  FORM_AUTH_COMPLETE,
} from './constants'
import { FormPageAuthCompletePayload, FormSubmitPayload } from './types'

export const formLoaded = createAction(
  FORM_LOADED,
  (action) => (style: string, sourceType: string) => action({ style, sourceType })
)

export const writingFormSubmit = createStandardAction(
  WRITING_FORM_SUBMIT_REQUESTED
)<FormSubmitPayload>()

export const formSubmitStarted = createStandardAction(FORM_SUBMIT_START)()
export const formSubmitStopped = createStandardAction(FORM_SUBMIT_STOP)()
export const formSubmitted = createStandardAction(FORM_SUBMIT_SUCCEEDED)()
export const formSubmitFailed = createErrorAction(FORM_SUBMIT_FAILED)

export const formPageAuthComplete = createStandardAction(
  FORM_AUTH_COMPLETE
)<FormPageAuthCompletePayload>()
